import classnames from 'classnames'
import type { PropsWithChildren, FC } from 'react'
import React from 'react'

import styles from './Row.module.css'

type Props = {
  children?: React.ReactNode
  className?: string
  dataTestId?: string
  multipleRows?: boolean
  noBorder?: boolean
  noFixedHeight?: boolean
  sticky?: boolean
  secondary?: boolean
} & React.HTMLProps<HTMLDivElement>

export const Row: FC<PropsWithChildren<Props>> = React.memo(
  ({
    dataTestId,
    children,
    secondary,
    noBorder = false,
    sticky = false,
    multipleRows,
    noFixedHeight,
    className = '',
    ...other
  }) => {
    return (
      <div
        data-testid={dataTestId}
        style={other.style}
        className={classnames(styles.CalendarRow, className, {
          [styles.Sticky]: !!sticky,
          [styles.RowNoBorder]: noBorder,
          [styles.FlexColumn]: multipleRows,
          [styles.Secondary]: secondary,
          [styles.RowHeightAuto]: !!noFixedHeight
        })}
        {...other}
      >
        {children}
      </div>
    )
  }
)
